function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgDiseaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M462.521,512h-63.461c-8.317,0-15.059-6.742-15.059-15.059c0-8.317,6.742-15.059,15.059-15.059 h48.402V160.8L256,33.157L64.538,160.8v321.083h251.698c8.317,0,15.059,6.742,15.059,15.059c0,8.317-6.742,15.059-15.059,15.059 H49.479c-8.317,0-15.059-6.742-15.059-15.059V152.739c0-5.036,2.516-9.737,6.706-12.529L247.647,2.529 c5.057-3.372,11.648-3.372,16.706,0L470.875,140.21c4.189,2.792,6.706,7.495,6.706,12.529v344.203 C477.58,505.259,470.838,512,462.521,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE8FA"
    },
    d: "M320.063,160.217c-19.208,0-31.619,8.535-31.619,21.745v56.195h-64.888v-56.195 c0-13.21-12.411-21.745-31.619-21.745s-31.621,8.535-31.621,21.745v172.443c0,12.991,13.002,22.064,31.621,22.064 c18.617,0,31.619-9.073,31.619-22.064v-64.476h64.888v64.476c0,12.991,13.002,22.064,31.619,22.064s31.619-9.073,31.619-22.064 V181.962C351.682,168.753,339.272,160.217,320.063,160.217z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M320.063,391.53c-27.047,0-46.678-15.613-46.678-37.123V304.99h-34.771v49.417 c0,21.512-19.631,37.123-46.678,37.123s-46.679-15.613-46.679-37.123V181.962c0-18.321,14.434-36.804,46.679-36.804 s46.678,18.485,46.678,36.804v41.136h34.771v-41.136c0-18.321,14.432-36.804,46.678-36.804s46.678,18.485,46.678,36.804v172.443 C366.741,375.917,347.111,391.53,320.063,391.53z M223.556,274.871h64.888c8.317,0,15.059,6.742,15.059,15.059v64.476 c0,3.384,6.655,7.005,16.56,7.005c9.906,0,16.56-3.623,16.56-7.005V181.962c0-4.39-8.331-6.686-16.56-6.686 s-16.56,2.296-16.56,6.686v56.195c0,8.317-6.742,15.059-15.059,15.059h-64.888c-8.317,0-15.059-6.742-15.059-15.059v-56.195 c0-4.39-8.331-6.686-16.56-6.686c-8.23,0-16.562,2.296-16.562,6.686v172.443c0,3.384,6.654,7.005,16.562,7.005 c9.906,0,16.56-3.623,16.56-7.005v-64.476C208.497,281.614,215.239,274.871,223.556,274.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D527C"
    },
    d: "M316.235,450.258H195.765c-8.317,0-15.059-6.742-15.059-15.059c0-8.317,6.742-15.059,15.059-15.059 h120.471c8.317,0,15.059,6.742,15.059,15.059C331.294,443.516,324.552,450.258,316.235,450.258z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiseaseIcon);
export default __webpack_public_path__ + "static/media/disease-icon.f6046e94.svg";
export { ForwardRef as ReactComponent };